import { Emblem } from "@/components/brand/Emblem";

import { Button } from "./Button";
import { SpinnerIcon } from "./icons";

export function FullScreenLoader({ label }: { label: string }) {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-5 px-4" aria-busy>
      <Emblem className="size-14 animate-pulse" />
      <p className="flex items-center gap-2 text-body-md text-on-surface-variant" role="status">
        <SpinnerIcon className="size-4" />
        {label}
      </p>
    </main>
  );
}

type FullScreenErrorProps = {
  title: string;
  message: string;
  onRetry?: () => void;
};

export function FullScreenError({ title, message, onRetry }: FullScreenErrorProps) {
  return (
    <main className="flex min-h-full flex-col items-center justify-center gap-6 px-4 text-center">
      <Emblem className="size-14" />
      <div className="max-w-sm">
        <h1 className="text-headline-sm">{title}</h1>
        <p className="mt-2 text-body-md text-on-surface-variant">{message}</p>
      </div>
      {onRetry ? (
        <Button variant="secondary" className="h-11" onClick={onRetry}>
          Try again
        </Button>
      ) : null}
    </main>
  );
}